import React, {Component} from 'react'
import ReactModal from 'react-modal'
import $ from 'jquery'
import styles from './Modal.less'

import Icon from './icon/Icon';

const MODAL_PORTAL_PARENT_ID = 'helpdesk_bsplugin_modal_portal_parent'
if ($(`#${MODAL_PORTAL_PARENT_ID}`).length == 0) {
    const $modal_portal = $('<div></div>').attr('id', MODAL_PORTAL_PARENT_ID)

    $('body').append($modal_portal)
}

export default class Modal extends Component {
    render() {
        const {onClose, children, wide, ...props} = this.props
        let {style} = this.props
        const {closeButton: closeButtonClass} = styles

        const defaultStyle = {
            content: {
                border: '0',
                boxShadow: '0 0 20px rgba(0, 0, 0, .6)',
                width: '700px',
                top: '100px',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginLeft: '-350px',
                marginBottom: '100px',
                // overflow: 'visible',
                // overflowY: 'auto',
                maxHeight: '75%',
            },
            overlay: {
                zIndex: '150',
                background: 'rgba(0, 0, 0, .5)',
                // overflow: 'auto'
            }
        }

        if (wide) {
            defaultStyle.content.width = '1200px'
            defaultStyle.content.marginLeft = '-600px'
        }

        if (!style) {
            style = {
                content: {},
                overlay: {}
            }
        } else if (!style.content) {
            style.content = {}
        } else if (!style.overlay) {
            style.overlay = {}
        }

        style.content = Object.assign(defaultStyle.content, style.content)
        style.overlay = Object.assign(defaultStyle.overlay, style.overlay)

        if (!props.ariaHideApp) {
            props.ariaHideApp = false
        }

        props.parentSelector = () => window.document.getElementById(MODAL_PORTAL_PARENT_ID)

        return (
            <ReactModal style={style} onRequestClose={onClose} {...props}>
                <div>
                    <div className={closeButtonClass} onClick={onClose}>
                        <Icon name="no-bw"/>
                    </div>
                    {children}
                </div>
            </ReactModal>
        )
    }
}